RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const PostsWithKeywordModal = RivalIQ.apps.Discovery.views.PostsModal.extend({

        onBeforeRenderLoaded: function () {
            const me = this;

            const Widget = Marionette.Dashboard.widgets.get(RivalIQ.enums.widgetTypes.INSIGHTS_MEDIA);

            const postMetrics = App.utils.getDefaultPostColumnsForPostsModal(me.dashboardModel);

            const widget = new Widget(me.dashboardModel, {
                props: _.extend({}, me.dashboardModel.attributes, {
                    post_metrics: postMetrics,
                    dimensions: ['timeAnalysisMode', 'post', 'channel', 'companyId'],
                    columnLimit: null,
                    layout: 'list',
                    orderBy: 4,
                    sortTable: false,
                    trailingBar: false,
                    // fake value to make widget render in details mode
                    widgetId: true,
                    // no post details modal
                    noClickThrough: true,
                    analysisProperty: undefined,
                    // load the specific posts that were part of this keyword cluster
                    postIds: me.getProp('postIds'),
                    modalWidget: true
                })
            });

            me.posts.showWidget(widget, null, {
                forceLoadingView: true
            });
        },

        loadData: function () {
            const me = this;

            // NOTE we are just returning totals here, so we don't want to even
            // think about ordering (which can cause errors when misconfigured,
            // see #22607)
            const props = _.omit(me.getProps(), ['orderBy']);

            const metricAttrs = {
                dimensions: ['timeAnalysisMode', 'channel', 'companyId', props.analysisProperty],
                property: 'count',
                channel: props.channel
            };

            const definition = App.utils.createInsightsMetric(props.objectType, metricAttrs);

            const metric = new RivalIQ.models.MetricDefinition(RivalIQ.metric.build(props, definition, {
                clobberDimensions: true
            }));

            return metric.fetch()
                .then(function (result) {
                    me.totalNumPosts = result.getValue({
                        format: false
                    });
                    me.numPostsShownMetric = Math.min(props.limit, me.totalNumPosts);
                });
        },

        serializeData: function () {
            const me = this;

            const channelName = RivalIQ.data.channels.get(RivalIQ.enums.sourceDetails[me.getProp('source')].channel).get('name');
            const postWord = `${_.upperFirst(RivalIQ.data.channels.get(me.getProp('channel')).get('postName'))}s`;

            return {
                title: `${channelName} ${postWord} about: ${me.getProp('keyword')}`,
                totalNumPosts: me.totalNumPosts,
                numPostsShownMetric: me.numPostsShownMetric
            };
        }
    });

    PostsWithKeywordModal.show = function (curation, props) {
        // NOTE we want to use a consistent limit (other post modals, like the
        // one in Social Posts, request 100 posts)
        props.limit = 100;

        const dashboardModel = new RivalIQ.apps.Dashboard.models.Curation(null, props);
        // NOTE see #20498
        dashboardModel.presence = curation.getCuration().presence;
        RivalIQ.execute('show:modal', new PostsWithKeywordModal({
            dashboardModel: dashboardModel
        }));

        RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ViewedInsightsPostsModal);
    };

    const KeywordCell = RivalIQ.apps.SocialPosts.views.HashtagNameCell.extend({
        tagName: 'td',
        className: 'metric-table-cell',
        template: '#insightsKeywordsCellTemplate',

        getParams: function (dashboardModel) {
            const params = _.pick(dashboardModel.getProps(), App.utils.validCurationOptions);
            return params;
        },

        templateHelpers: function () {
            const me = this;
            const data = me.getOption('data');

            const child = {};
            // Set the relevant dimension to undefined to get the correct name
            child[me.model.get('dimension')] = undefined;
            const metric = me.model.build(child);

            return _.extend({
                name: metric.format(data[0])
            }, RivalIQ.utils.emoji.getTemplateHelpers());
        }
    });

    const TableView = RivalIQ.apps.Dashboard.widgets.MetricTable.mixin({

        mixins: {
            LoadDataWithBuffering: RivalIQ.apps.Dashboard.mixins.LoadDataWithBuffering
        },

        ui: _.defaults({
            tooltips: '[data-toggle="tooltip"]'
        }, RivalIQ.apps.Dashboard.widgets.MetricTable.prototype.ui),

        rowClassName: 'discovery-table-row pointer',

        emptyViewOptions: function () {
            const me = this;
            const channel = me.getProp('channel');
            return {
                channel: channel
            };
        },

        emptyView: Marionette.ItemView.extend({
            template: '#insightsKeywordsWidgetNoResultsTemplate',
            serializeData: function () {
                const me = this;

                const postName = RivalIQ.data.channels.get(me.getOption('channel')).get('postName');
                return {
                    postName: `${postName}s`
                };
            }
        }),

        getFetchAttributes: function () {
            const me = this;

            const metrics = me.metricsCollection;

            let orderByIdx = Number(me.getProp('orderBy'));
            if (!_.isFinite(orderByIdx)) {
                orderByIdx = metrics.indexOf(metrics.findWhere({
                    property: me.getProp('orderBy')
                }));
            }

            me.sortColumns = me.metricsCollection.getColumnSortOrder(orderByIdx);

            return {
                keywordsLimit: Number(me.getProp('limit') || 0),
                limit: 0,
                sortOrder: Number(me.getProp('sortOrder') || 1),
                orderBy: metrics.at(me.sortColumns[0]).get('property')
            };
        },

        _loadData: function () {
            const me = this;
            const postIdMetric = me.metricsCollection.at(0).build({
                property: 'post'
            });


            const postIdsFetch = postIdMetric.fetch(me.getFetchAttributes());

            return $.when(postIdsFetch, RivalIQ.apps.Dashboard.widgets.MetricTable.prototype.loadData.call(me))
                .then(function (postIdsMetric) {
                    me.keywordToPostIds = _(postIdsMetric.getValue())
                        .keyBy(_.head)
                        .mapValues(function (keywordData) {
                            return keywordData[1].postIds;
                        })
                        .value();
                });
        },

        onRender: function () {
            const me = this;
            me.ui.tooltips.tooltip();
        },

        onRowClick: function (data, e) {
            const me = this;

            e.preventDefault();

            // NOTE the keyword value for this row is in the first column of every row of data
            const targetKeyword = data[0][0];
            PostsWithKeywordModal.show(me.dashboardModel.curation, _.extend(me.getProps(), {
                keyword: targetKeyword,
                postIds: me.keywordToPostIds[targetKeyword]
            }));
        }
    });

    const KeywordsTable = RivalIQ.apps.Dashboard.widgets.TableWidget.extend({
        view: TableView,
        tableClassName: 'table-fix',

        processProps: function (props) {
            const me = this;

            props = _.defaults(props, {
                sortable: true,
                orderBy: 1,
                sortOrder: 1,
                showProgressBar: true
            });

            if (props.objectType === RivalIQ.enums.insightsObjectType.post && props.source === RivalIQ.enums.sources.INSTAGRAM_INSIGHTS && _.isEmpty(props.post_metrics)) {
                const hasPaidEngagement = App.utils.hasInstagramPaidEngagement(me);
                if (hasPaidEngagement) {
                    props.post_metrics = [
                        'posts_about',
                        'impressions',
                        'engagement_rate_by_impression'
                    ];
                    props.detail_view_metrics = [
                        'impressions_per_post',
                        'engagement_total_per_post',
                        'video_views',
                        'video_views_per_post'
                    ];
                } else {
                    props.post_metrics = [
                        'posts_about',
                        'organic_impressions',
                        'organic_engagement_rate_by_impression'
                    ];
                    props.detail_view_metrics = [
                        'organic_impressions_per_post',
                        'organic_engagement_total_per_post',
                        'organic_video_views',
                        'organic_video_views_per_post'
                    ];
                }
            }

            App.utils.buildInsightsTableMetrics(me, {
                property: 'name',
                dimensions: [props.analysisProperty],
                sortable: false,
                cellView: _.constant(KeywordCell)
            }, props);

            return props;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INSIGHTS_KEYWORDS_TABLE, KeywordsTable);

    // return an array of metric properties that are in the order metrics should be sorted
    const getKeywordsMetrics = function () {

        return ['posts_about', 'engagement_total_per_post'];
    };

    const KeywordsView = App.views.KeywordsView = RivalIQ.views.LayoutView.mixin({
        template: '#insightsKeywordsWidgetViewTemplate',

        regions: {
            table: '.x-table'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            normalizeHeights: RivalIQ.apps.Dashboard.mixins.NormalizeHeights
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        loadData: function () {
            const me = this;
            const props = me.getProps();

            me.metric = new RivalIQ.models.MetricDefinition(me.dashboardModel.baseMetric);

            const metrics = _.map(getKeywordsMetrics(props.source, props.objectType), function (property) {
                return me.metric.build({
                    dimensions: [props.analysisProperty],
                    property: property
                });
            });

            const collection = new RivalIQ.collections.MetricDefinitions(metrics);

            return collection.fetch();
        },

        onBeforeRenderLoaded: function () {
            const me = this;
            me.showTable();
        },

        showTable: function () {
            const me = this;

            const widget = me.dashboardModel.getWidget('keywords-table');
            me.table.showWidget(widget, {
                className: `table-double-header ${me.dashboardModel.isExporting() ? 'x-table-container' : 'table-responsive'}`
            });
        }
    });

    const DetailPanelView = RivalIQ.apps.Dashboard.views.Panel.extend({

        showActions: function () {
            const me = this;

            if (me.dashboardModel.isFocus()) {

                const postWord = `${_.upperFirst(RivalIQ.data.channels.get(me.getProp('channel')).get('postName'))}s`;

                const MinimumPostsDropdown = RivalIQ.apps.SocialPosts.utils.createNumericFilterDropdown({
                    label: `Min. ${postWord}`,
                    prop: 'keywordsMinPosts',
                    propDefaultValue: 2,
                    min: 1,
                    max: 10
                });

                me.actions.show(new MinimumPostsDropdown({
                    dashboardModel: me.dashboardModel
                }), {
                    preventDestroy: true
                });
            }

            if (!me.dashboardModel.isFocus()) {
                me.showExportDropdown();
            }
        }
    });

    const KeywordsUsage = RivalIQ.apps.Dashboard.models.Widget.mixin({
        view: KeywordsView,
        detailPanelView: DetailPanelView,
        title: 'Popular Topics',
        getExportTitle: App.utils.insightsExportTitle,
        getExportSubtitle: App.utils.insightsExportSubtitle,
        getPptSubtitle: App.utils.insightsPptSubtitle,
        description: function () {
            const me = this;

            const postWord = RivalIQ.data.channels.get(me.getProp('channel')).get('postName');
            return RivalIQ.str('insights_keywords_info', postWord);
        },

        exportFormats: [
            RivalIQ.enums.exportFormat.PPT,
            RivalIQ.enums.exportFormat.PDF,
            RivalIQ.enums.exportFormat.PNG,
            RivalIQ.enums.exportFormat.CSV
        ],
        scheduledExportAdvancedSettingsEnabled: false,

        propsToSerializeForExport: [
            'keywordsMinPosts'
        ].concat(App.utils.widgetExportProps),

        viewMorePath: function () {
            const me = this;

            return me.getPath({
                limit: -1,
                orderBy: me.getProp('orderBy'),
                sortOrder: me.getProp('sortOrder')
            });
        },

        filter: function () {
            const me = this;

            const objectType = me.getProp('objectType');
            const isPostObjectType = (objectType === RivalIQ.enums.insightsObjectType.post);

            return (isPostObjectType && RivalIQ.apps.Insights.utils.isLoadingInstagramPromotedPosts(me));
        },

        processProps: function (props) {
            const me = this;

            _.defaults(props, {
                limit: 8,
                analysisProperty: 'keyword',
                omitTimeAnalysisModeDescription: true
            });

            me.baseMetric = App.utils.createInsightsMetric(props.objectType, _.defaults({
                dimensions: ['timeAnalysisMode', 'channel', 'companyId']
            }, props));

            return props;
        },

        csvExportProps: function () {
            const me = this;
            const props = me.getProps();

            return {
                type: 'keywords',
                isPrivateData: true,
                analysisProperty: props.analysisProperty,
                metric: _.defaults({
                    limit: -1,
                    startDate: me.baseMetric.timePeriod.mainPeriodStart,
                    endDate: me.baseMetric.timePeriod.mainPeriodEnd
                }, me.baseMetric)
            };
        },

        widgetDefinitions: function () {
            const me = this;

            const props = {
                showDescriptions: true
            };

            const widgets = [{
                instanceId: 'keywords-table',
                neverFilter: true,
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_KEYWORDS_TABLE,
                baseMetric: me.baseMetric,
                props: props
            }];

            return widgets;
        },

        allowPageBreaks: App.utils.allowPageBreaksInFocus
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INSIGHTS_KEYWORDS, KeywordsUsage);
});
